// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2P0eh","left":"Input_left__jsuuA","center":"Input_center__0wp_d","right":"Input_right__aS2bm","button":"Input_button__pLeTA","empty":"Input_empty__9R50J"};